import { ApplicationInsights, IConfiguration, IEventTelemetry } from '@microsoft/applicationinsights-web';
import React from 'react';

import { adalConfig, authContext, loadCurrentUser } from './adalConfig';
// import { socket } from './data';
import UserContext from './UserContext';

console.log('UserProvider !!!');

class UserProvider extends React.Component<any, any> {

  appInsights?: ApplicationInsights;

  constructor(props: any) {
    super(props);

    this.state = {
      currentUser: null,
      environments: [],
      translations: {}
    };


    // app insights

    if (process.env.REACT_APP_TELEMETRY_KEY) {
      const config: IConfiguration = {
        instrumentationKey: process.env.REACT_APP_TELEMETRY_KEY,
      };

      this.appInsights = new ApplicationInsights({
        config
      });

      this.appInsights.loadAppInsights();
    }


    // load current user

    loadCurrentUser(this.setCurrentUser);
  }



  setCurrentUser = async (user: any, environments: any[], translations: any) => {

    if (!this.state.currentUser || (this.state.currentUser && this.state.currentUser.name !== user.name)) {


      // socket
      // socket.authenticate();


      // state
      await this.setState({
        currentUser: user,
        environments,
        translations
      });


      // app insights
      if (this.appInsights) {
        const event: IEventTelemetry = {
          name: 'webTelemetry',
          measurements: {
            height: window.innerHeight,
            width: window.innerWidth
          },
          properties: {
            browser: navigator.userAgent,
            email: this.state.currentUser && this.state.currentUser.email,
            env: process.env.NODE_ENV,
            name: this.state.currentUser && this.state.currentUser.name
          }
        };

        this.appInsights.setAuthenticatedUserContext(this.state.currentUser?.email || '');
        this.appInsights.trackEvent(event);
        this.appInsights.flush();
      }



    } else {

      // state
      await this.setState({
        currentUser: user,
        environments,
        translations
      });
    }
  }



  logout = () => {
    authContext.clearCache();
    window.location.replace(`https://login.microsoftonline.com/${adalConfig.tenant}/oauth2/logout?post_logout_redirect_uri=${adalConfig.postLogoutRedirectUri}`);
  }



  hasPermission = (resource: string, permission: string, log?: false) => {
    if (log) {
      console.log('hasPermission', resource, permission);
    }

    // return this.state.currentUser?.role?.permissions?.[resource]?.includes(permission);

    return true;
  }



  render() {

    const value = {
      currentUser: this.state.currentUser,
      setCurrentUser: this.setCurrentUser,
      logout: this.logout,
      hasPermission: this.hasPermission,
      environments: this.state.environments,
      translations: this.state.translations
    };

    return(
      <UserContext.Provider value={value}>
        {this.props.children}
      </UserContext.Provider>
    );
  }
}

export default UserProvider;
